module.exports = __webpack_public_path__ + "media/Adiantar.1c2e8d58.mp3";